module.exports = __webpack_public_path__ + "static/images/no-image.2gOs_0G.png";